export default "__VITE_ASSET__DvfLjZEI__"